import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IWinRatioConfig} from "../interfaces/Interface";
import {GameFeatureMode, WinRatioType} from "../enums/Enum";
import {Sound} from "../sound/Sound";

export class WinRunner implements SimplePresentation {

    private _mainTL: gsap.core.Timeline;

    shouldRun(): boolean {
        return Game.model.gameData.betWayWins.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mainTL = new gsap.core.Timeline();
        this._mainTL.to({}, {duration: 0.2});
        this._mainTL.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(this._mainTL);
            });
        });

        if (Game.model.isBigWin) {
            if(Game.model.gameData.mode === GameFeatureMode.RESPIN){ //Xmental check
                Game.soundPlayer.fadeSound(1, 0, 10, Sound.X_MENTAL_SPIN_LOOP);
            }else{
                Game.soundPlayer.fadeSound(1, 0, 1000);
            }
        }

        this._mainTL.add([
            () => {
                this.playPreWinSound();
                if (Game.model.isBigWin) {
                    Game.soundPlayer.playSound(Sound.BIGWIN_INIT);
                }
            },
            this.playHighlight(),
            Game.winWaysView.showInitialWinWays()
        ]);
        this._mainTL.add(Game.winHighlightView.playBigWinAnticipation());

        this._mainTL.add(() => {
            controller.finish();
        })
    }

    public playPreWinSound(): void {
        let winRatioConfig: IWinRatioConfig = Game.model.winRatioConfig;
        let sound: string = Sound.PRE_WIN_TINY_SMALL_MEDIUM;

        if (winRatioConfig && winRatioConfig.type === WinRatioType.LARGE) {
            sound = Sound.PRE_WIN_LARGE;
        }
        if (!Game.isWinBelowStake()) {
            Game.soundPlayer.playSound(sound);
        }
    }

    private playHighlight(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const animName: string = (Game.model.winRatioConfig.duration > 0.001 ? "intenseFrame" : "frame");
        Game.model.gameData.allWinPos.forEach((reels: boolean[][], reelId: number) => {
            reels.forEach((splits: boolean[], rowId: number) => {
                tl.add(Game.winHighlightView.play(reelId, rowId, animName, splits, true), 0);
            });
        });
        return tl;
    }

    private onSkip(tl: gsap.core.Timeline): void {
        Game.winHighlightView.stopBigWinAnticipation();
        tl.totalProgress(1);
    }

}